//const SpringConfigsDev: any = {};

// @ts-nocheck

import { gamblingLogoURL } from 'utils/constants/casino/gambling-logo-url';
import { isMobile } from 'utils/is-mobile';
import { EDateDayMonthOrder } from '../../interfaces/generic';
import { ETopLeagueLayoutType } from '../../interfaces/sportsbook-configs';

const matchTrakerType = {
  0: 'https://widget-iframe.wadua.io',
  1: 'https://widget-iframe.awidua.io'
};

//window.refreshWhenLoggedIn = true;

/* eslint-disable */
/* prettier-ignore */
const SpringConfigsDev: any = {
    //PARTNER_ID:                                   1877029,
    PARTNER_ID:                                   18749751,
    // PARTNER_ID:                                   1874631,
    //PARTNER_ID:                                   1310,
    //PARTNER_ID:                                  4,
    //PARTNER_ID:                                   4,
    //PARTNER_ID:                                   18757987,
    //PARTNER_ID:                                   18751869, //euro888
    //PARTNER_ID:                                   1869622, //barier//
    SOURCE:                                       isMobile() ? 4 : 42,
    WRAPPER_APP:                                  true,
    //SWARM_URL:  z                                  'wss://eu-swarm-ws-re.fjykjczttspydxcx.com',
    //SWARM_URL:                                    'wss://eu-swarm-ws-re.betconstruct.com',
    //SWARM_URL:                                    'wss://eu-swarm-newm.betcoswarm.com/',
    // SWARM_URL:                                    'wss://swarm.h2.bet.br/',
    SWARM_URL:                                    'wss://eu-swarm-springre.trexname.com',
    //SWARM_URL:                                    'wss://swarm-2.vbet.fr/',
    CASINO_URL:                                   'https://go.cmsbetconstruct.com/casino',
    JACKPOT_URL:                                  'wss://rgs-wss.betconstructapps.com/jackpot',
    GEO_LINK_URL:                                 'https://geoapi.bcapps.net',
    //A_TO_Z_MENU_DATA_PATH:                        "https://static.springbuilder.me/fs/userFiles-v2/betingo-18750689/data/springXConfigs/aToZJsonPath.json?v=1681999660",
    //A_TO_Z_MENU_DATA_PATH:                        "https://static.springbuilder.site/fs/userFiles-v2/10x10bet-18749214/data/springXConfigs/aToZJsonPath.json?v=1737966036",
    A_TO_Z_MENU_DATA_PATH:                        "https://static.springbuilder.site/fs/userFiles-v2/vbetde-18764169/data/springXConfigs/aToZJsonPath.json?v=1742138971",
    // A_TO_Z_MENU_DATA_PATH:                        "https://static.springbuilder.site/fs/userFiles-v2/sbx-18746755/data/springXConfigs/aToZJsonPath.json",
    // ACCOUNT_REGISTRATION_JSON_PATH:               "https://static.springbuilder.site/fs/userFiles-v2/17-bet-18756755/data/springXConfigs/v3RegFields.json",
    //ACCOUNT_REGISTRATION_JSON_PATH:               "https://static.springbuilder.site/fs/userFiles-v2/arttest-1877801/data/springXConfigs/v3RegFields.json",
    //ACCOUNT_REGISTRATION_JSON_PATH:               "https://www.liveresults365.com/fs/userFiles-v2/demo-springbuilder-x/data/springXConfigs/v3RegFields.json?v=1706713938",

    //ACCOUNT_REGISTRATION_JSON_PATH:               "https://www.liveresults365.com/fs/userFiles-v2/demo-springbuilder-x/data/springXConfigs/v3RegFields.json",
    //ACCOUNT_REGISTRATION_JSON_PATH:               "https://static.springbuilder.site/fs/userFiles-v2/hayktest-18746410/data/springXConfigs/v3RegFields.json?v=1685449808",
    //ACCOUNT_REGISTRATION_JSON_PATH:               "https://static.springbuilder.site/fs/userFiles-v2/testing2/data/springXConfigs/v3RegFields.json",
    ACCOUNT_REGISTRATION_JSON_PATH:                 "https://static.springbuilder.site/fs/userFiles-v2/vbetde-18764169/data/springXConfigs/v3RegFields.json?v=1737366453",
    //SECTIONS_JSON:                                "https://static.springbuilder.site/fs/userFiles-v2/vbetx-18749655/data/springXConfigs/accountSectionsJsonPath.json",
    SECTIONS_JSON:                                 "https://static.springbuilder.site/fs/userFiles-v2/france-18746848/data/springXConfigs/accountSectionsJsonPath.json",
    //ACCOUNT_PARAMS:                               "https://static.springbuilder.site/fs/userFiles-v2/barrierebet-springbuilderx-1876269/data/springXConfigs/settings.json",
    //ACCOUNT_PARAMS:                     "https://static.springbuilder.site/fs/userFiles-v2/france-18746848/data/springXConfigs/settings.json",
    ACCOUNT_PARAMS:                       "https://www.grandcasino.by/fs/userFiles-v2/grandcasinox-18748282/data/springXConfigs/settings.json",
    USER_FILES_URL:                               window.partnerConfigs?.userFilesUrl || 'https://developers13.betconstruct.me/userFiles/developers13',
    TERMS_LINK:                                   'https://www.betconstruct.com',
    TERMS_POPUP_LINK:                             'https://www.betconstruct.com',
    PRIVACY_POLICY_LINK:                          'https://www.betconstruct.com',
    TERMS_LINK_TARGET:                            '1',
    PRIVACY_POLICY_TARGET:                        '1',
    STORAGE_URL :                                 'https://static.springbuilder.site/',
    LANGUAGE_PREFIX:                              'eng',
    MATCHTRACKER_LANG_PREFIX:                     'eng',
    CURRENT_LANGUAGE:                             'en',
    ODD_ROUNDING:                                 3,
    PRICE_ROUNDING:                               2,
    PRICE_SEPARATOR:                              ',',
    HIDE_TRAILING_ZEROES:                         true,
    VERSION:                                      123456,
    IS_TOP_NAVIGATION_BUTTON_ENABLED:             false,
    TOP_NAVIGATION_BUTTON_POSITION:               'right',
    TOP_NAVIGATION_BUTTON_ALIGNMENT:              'bottom',
    DIRECTION:                                    'ltr',
    CASINO_GAMES_FETCH_MAX_COUNT:       30,

    /**  CASINO  **/
    CASINO_GAME_SWITCHING_DURING_GAME_SESSION:    true,
    CASINO_GAMES_FETCH_COUNT:                     16,
    CASINO_MOBILE_IFRAME:                         true,
    CASINO_SPORTSBOOK_SWITCHER:                   2,
    CASINO_GAMBLING_LOGO_URL:                     gamblingLogoURL,
    CASINO_HIGH_QUALITY_PICTURES:                 false,
    CASINO_GAME_URL_PREFIX:                       'games',
    CASINO_MOUNT_PATH:                            'slots',
    CASINO_GAME_SIDEBAR_ENABLED:                  true,
    CASINO_FUN_MODE:                              true,

    /**  SPORTSBOOK  **/
    SPORTSBOOK_MOUNT_PATH:                        'match',
    SPORT_MENU_DEFAULT_SELECTED:                  'sportsTypes',
    SPORT_MARKET_IS_COMPACT:                      0,
    SPORT_COMPETITION_IS_COMPACT:                 0,
    IS_BOOK_BET_AVAILABLE:                        true,
    IS_QUICK_BET:                                 true,
    IS_BOOSTED_ODDS_ENABLED:                      true,
    IS_MULTIPLES_ENABLED:                         true,
    IS_EDIT_BET_AVAILABLE:                        true,
    IS_BETSLIP_FLOATING_ENABLED:                  false,
    IS_BETSLIP_FLOATING_ENABLED_MOBILE:           false,
    BOTTOM_NAVIGATION: false,
    TEAM_LOGOS:                                   true,
    PUSH_NOTIFICATIONS_ENABLED:                   true,
    BETS_WITH_SAME_GROUP:                         true,
    OPEN_BETS_BY_DEFAULT:                         1,
    BETSLIP_TYPE:                                 0,
    SPORTSBOOK_ICON_STYLE:                        'colored',
    FLAG_STYLE:                                   'circled',
    MATCH_TRACKER_URL:                            matchTrakerType[window?.partnerConfigs?.matchTrackerType || 0],

    /**  ACCOUNT  **/
    USER_AUTOLOGIN:                               true, // ATTENTION must be transfered to account settings json
    GIFT_BET:                                     true,
    IS_PRINT_AVAILABLE:                           false,
    REMOVE_SUSPENDED_SELECTION:                   false,
    SEON_INTEGRATION:                             true,
    SEON_VALIDATION_ACTION:                       'all',
    THEME_SWITCHER:                               true,

    /**  MISC  **/
    MOCKED_DATA:                                  false,
    JURISDICTION:                                 '0',
    BOTTOM_NAV_VALIDATION:                        true,
    IS_WEBP_SUPPORTED:                            null,
    DT:                                           {
        shortDate:  'DD MMM',
        longDate:   'DD MMM YYYY',
        time:       'HH:mm',
        longTime:   'HH:mm:ss'
    },

    PAGE_URLS:                                    {
        live:
            !isMobile()
                ? `${window.location.origin}/desktop-sportsbook-live`
                : `${window.location.origin}/live1`,
        prematch:
            !isMobile()
                ? `${window.location.origin}/desktop-sportsbook-prematch`
                : `${window.location.origin}/prematch`,
        casino:       `${window.location.origin}/casino`,
        racing:       `${window.location.origin}/racing`,
        tournaments:  `${window.location.origin}/tournament`,
        esport:       `${window.location.origin}/esports`
    },

    /**  CUSTOM CODES  **/
    APPEND_CUSTOM_CODE_LOGIN:                     false,
    CUSTOM_CODE_LOGIN:                            '',
    APPEND_CUSTOM_CODE_REG:                       false,
    CUSTOM_CODE_REG:                              '',
    APPEND_CUSTOM_CODE_DEPOSIT:                   false,
    CUSTOM_CODE_DEPOSIT:                          '',
    APPEND_CUSTOM_CODE_BETSLIP:                   false,
    CUSTOM_CODE_BETSLIP:                          '',
    APPEND_CUSTOM_CODE_FIRST_DEPOSIT:             false,
    CUSTOM_CODE_FIRST_DEPOSIT:                    '',
    APPEND_CUSTOM_CODE_DEPOSIT_FAIL:              true,
    CUSTOM_CODE_DEPOSIT_FAIL:                     '<script>console.log("@@gender", "gendertesst"), console.log("@@name", "gendertesst")</script>',
    APPEND_CUSTOM_CODE_LOGIN_FAIL:                false,
    CUSTOM_CODE_LOGIN_FAIL:                       '',



    BET_BUILDER_URL:                              'https://betconstruct-prod-gen2.sportcastlive.com/markets?key=a6aa080b-cea9-4e3f-aa02-9fef8d1f0c8f&fixtureid=',
    IS_ACTIVE_STREAM_TAB:                         true,
    OUTRIGHT_FILTER:                              0,
    CAROUSEL_ARROWS:                              false,
    BET_BUILDER_SWITCHER:                         true,
    CURRENCIES_WITH_SYMBOLS:                      false,
    REALITY_CHECK_SWITCHER:                       false,
    DEFAULT_ODD_ACCEPT:                           "2",
    CURRENT_COUNTRY_CODE:                         "AM",
    ODD_TYPE:                                     ["decimal","fractional","american","hongkong","malay","indo"],
    DEFAULT_ODD_TYPE:                             "decimal",
    IS_BET_STATUS_CHECKER_AVAILABLE :             false,
    STATISTICS_SWITCHER:                          true,
    STATISTICS_URL:                               'https://statistics.vbet.com/',
    PREDEFINE_STAKES_ENABLE:                      true,
    PREDEFINE_STAKE_1:                            1,
    PREDEFINE_STAKE_2:                            2,
    PREDEFINE_STAKE_3:                            5,
    IS_PARTIAL_CASHOUT_AVAILABLE :                false,
    IS_ALLOW_BONUS_BALANCE_SUPERBET :             false,
    HOMEWORK_ENABLED:                             false,
    APPEND_CUSTOM_CODE_REGISTER_FAIL:             true,
    CUSTOM_CODE_REGISTER_FAIL:                    '<script>console.log("deposit fail custom code appended")</script>',
    APPEND_CUSTOM_CODE_WITHDRAW:                  true,
    CUSTOM_CODE_WITHDRAW:                         '<script>console.log("WITHDRAW fail custom code appended")</script>',
    APPEND_CUSTOM_CODE_LOGIN:                     false,
    CUSTOM_CODE_LOGIN:                            '',
    SHOW_SITE_NAME_IN_TITLE:                      3,
    SPORT_TOURNAMENTS: true,
    INCLUDE_SPORT_DATA_IN_META: true,
    IFRAME_SPORTSBOOK: false,

    //POSTGRID_API_KEY:                           'live_pk_cSpKnT8EZ8LXJwR7xT7rU',
    //POSTGRID_API_URL:                           'https://api.postgrid.com/v1/addver',
    //POSTGRID_API_INTERNATIONAL_URL:             'https://api.postgrid.com/v1/intl_addver',

    /** GPS Tracking **/
    GPS_TRACKING_URL :                            window.geolocationUrl || 'https://geolocation.bcapps.net',
    GPS_TRACKING_ENABLED :                        window?.partnerConfigs?.GPSTrackingEnabled || false,
    GPS_TRACKING_CHECKING_INTERVAL :              window?.partnerConfigs?.GPSTrackingCheckingInterval || 5000,

    TODAY_EVENTS:                       true,
    LEFT_SIDE_BAR:                                true,
    LEFT_SIDE_BAR_SPORTS:                         true,
    LEFT_SIDE_BAR_CASINO:                         true,
    TOP_LEAGUES: true,
    TOP_LEAGUES_LAYOUT:                 ETopLeagueLayoutType.expanded,
    BOTTOM_NAVIGATION: true,
    DEFAULT_LANGUAGE_PREFIX:                      window.getDefaultLanguagePrefix ? window.getDefaultLanguagePrefix() : window.currentLanguagePrefix || 'ru',
    METAMASK_LOGIN: false,
    PERSONALIZED_SPORTS: false,
    DEPOSIT_PROMO: false,
    SESSION_LIFE_TIME: 0,
    IOVATION_ENABLE: false,
    WORKER_URL:                         window.location.origin + '/betslip-worker.js',
    CALCULATE_POSSIBLE_WIN_WORKER_URL:            'https://www.vbet.co.uk/widgets-x/workers/calculate-possible-win-worker.js',
    SHOW_VERIFY_ACCOUNT_MODAL: true,
    LOGIN_FREEZE: false,
    //PRICE_SEPARATOR:                              window?.partnerConfigs?.priceSeparator ? ',' : ' ',
    CASINO_LAUNCH_TYPE:                           window.partnerConfigs?.casinoLaunchType || 0,
    CUSTOM_PAYMET_URL:                             'https://www.10xvb.com/fs/userFiles-v2/10x10bet-18749214/data/springXConfigs/payment.json?v=1739362890',
    COMMUNITY_CHAT_ENABLED: true,
    COMMUNITY_CHAT_USER_VERIFICATION_DISABLED: 0,
    FAST_TRACK_BRAND: false,
    OLYMPIC_COMPETITION:                 true,
    USER_PERSONALIZATION_ENABLED:                 true,
    OLYMPIC_COMPETITION_LAYOUT:          0,
    // ICON_EXTENSION:                               '',
    BETSLIP_BASE_UPDATE: true,
    IS_BOOKING_DOWNLOAD_AVAILABLE: true,
    IS_BOOK_BET_SHARING_AVAILABLE: true,
    //DATE_DAY_MONTH_ORDER: window?.partnerConfigs?.dateDayMonthOrder || EDateDayMonthOrder.monthFirst
};
/* eslint-enable */

export default SpringConfigsDev;
